// Absences are stored with their raw `loAType`, so every view has to translate it for display.
export const ABSENCE_TYPE_LABELS: Record<string, string> = {
  vacation: 'Urlaub',
  remaining_vacation: 'Resturlaub',
  special_leave: 'Sonderurlaub',
  sickness: 'Krank',
  sickness_sick_note: 'Krank mit AU',
  sickness_child: 'Kindkrank',
  sickness_child_sick_note: 'Kindkrank mit AU',
  training: 'Fortbildung',
  compensatory_leave: 'Ü frei',
  parental_leave: 'Elternzeit',
  exempted: 'Freigestellt',
  professional_ban: 'Berufsverbot',
};

// Some dialogs saved the German label as `loAType` while others saved the id, so both
// spellings exist in the data and have to be folded onto the id before comparing.
const ABSENCE_TYPE_IDS_BY_LABEL: Record<string, string> = Object.fromEntries(
  Object.entries(ABSENCE_TYPE_LABELS).map(([id, label]) => [label.toLowerCase(), id])
);

export const normalizeAbsenceType = (type?: string) => {
  if (!type) return '';
  if (ABSENCE_TYPE_LABELS[type]) return type;
  return ABSENCE_TYPE_IDS_BY_LABEL[type.trim().toLowerCase()] ?? type;
};

export const getAbsenceTypeLabel = (type?: string) =>
  ABSENCE_TYPE_LABELS[normalizeAbsenceType(type)] || type || '';
